import { buildSellersAttorneyContactCard } from '../../shared';

export const sellersAttorneyContactCard = buildSellersAttorneyContactCard(
  'counterpartyAttorney',
);
